import script from "./recordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./recordForm.vue?vue&type=script&setup=true&lang=js"

import "./recordForm.vue?vue&type=style&index=0&id=55f0554c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f0554c"]])

export default __exports__